export default __webpack_public_path__ + "static/media/instagramprimera.3cbf306b.svg";